import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { Injectable, Output } from '@angular/core';
import { Observable, BehaviorSubject, of, throwError } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { CampiService } from './campi.service';

@Injectable({
  providedIn: 'root'
})
export class CampiDataSource implements DataSource<ModelEventiCalamitosi.CampoModuloDTO> {

  public campoSubject = new BehaviorSubject<ModelEventiCalamitosi.CampoModuloDTO[]>([]);
  public campo$ub = this.campoSubject.asObservable();
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();
  private errorSubject = new BehaviorSubject<boolean>(false);
  public loadComplete = new BehaviorSubject<boolean>(false);
  public errors$ = this.errorSubject.asObservable();
  isLoading: boolean = false;
  errorMessage: string = null;

  private countSubject = new BehaviorSubject<number>(null);
  public counter$ = this.countSubject.asObservable();

  constructor(private campiService: CampiService) {
  }

  loadCampi(ipa: string,
    filter: ModelEventiCalamitosi.CampoSearchableDto,
    sortDirection: string,
    pageIndex: number,
    pageSize: number,
    predef: string) {

    this.loadingSubject.next(true);

    this.campiService.getList(pageIndex, pageSize, sortDirection, {
      codiceCampo: filter.codiceCampo,
      idTemplate: filter.idTemplate,
      tipologia: filter.tipologia,
      etichetta: filter.etichetta,
      descrizione: filter.descrizione,
      obbligatorio: filter.obbligatorio,
      visualizzabile: filter.visualizzabile
    }).pipe(
      catchError(err => {
        this.errorSubject.next(true);
        return throwError(err);
      }),
      catchError(err => {
        return of([]);
      }),
      finalize(() => this.loadingSubject.next(false))
    )
      .subscribe(result => {
        this.campoSubject.next(result['content']);
        this.countSubject.next(result['totalElements']);
      });
  }

  //Funzione di controllo che permette il mantenimento delle checkbox attive se si cambia pagina
  loadCampiWithCheck(
    controlList: ModelEventiCalamitosi.CampoModuloDTO[],
    filter: ModelEventiCalamitosi.CampoSearchableDto,
    sortDirection: string,
    pageIndex: number,
    pageSize: number,
    distribuito?: string,
    allAb?: string,
  ) {

    this.loadingSubject.next(true);

    this.campiService.getList(pageIndex, pageSize, sortDirection, {
      codiceCampo: filter.codiceCampo,
      idTemplate: filter.idTemplate,
      tipologia: filter.tipologia,
      etichetta: filter.etichetta,
      descrizione: filter.descrizione,
      obbligatorio: filter.obbligatorio,
      visualizzabile: filter.visualizzabile
    }).pipe(
      finalize(() => this.loadingSubject.next(false))
    )
      .subscribe(result => {
        let listCampi: ModelEventiCalamitosi.CampoModuloDTO[] = result['content'];
        let acl: string = sessionStorage.getItem('acl');


        if (allAb) {
          if (allAb === 'S') {
            listCampi.forEach(element => {
              if (distribuito === 'S') {
                if (element.flVisibilita === 'N' || !element.flVisibilita) element.editatoFE = true;
              }
              if (acl === "dgpe") {
                if (element.campoDgpe === 'S') element.flVisibilita = 'S';
              } else element.flVisibilita = 'S';
            });
            listCampi.forEach(element => {
              let present: boolean = false;
              controlList.forEach(controlEle => {
                if (controlEle.idCampo === element.idCampo) present = true;
              });
              if (present) element.flVisibilita = 'N';
            });
          } else if (allAb === 'N') {
            listCampi.forEach(element => {
              if (distribuito === 'S') {
                if (acl === "dgpe") {
                  if (element.campoDgpe === 'S') element.flVisibilita = 'N';
                }
                else {
                  if (element.flVisibilita === 'N') {
                    element.editatoFE = true;
                  }
                }
              }
              else element.flVisibilita = 'N';
            });
            listCampi.forEach(element => {
              let present: boolean = false;
              controlList.forEach(controlEle => {
                if (controlEle.idCampo === element.idCampo) present = true;
              });
              if (present) element.flVisibilita = 'S';
            });
          }
        }
        else {
          listCampi.forEach(element => {
            controlList.forEach(controlEle => {
              if (controlEle.idCampo === element.idCampo && controlEle.flVisibilita !== element.flVisibilita) {
                element.flVisibilita = controlEle.flVisibilita;
                element.editatoFE = true;
              }
            });
          });
        }
        this.campoSubject.next(listCampi);
        // nuova emissione per abilitazione
        // this.loadComplete.next(true);
        this.countSubject.next(result['totalElements']);
      },
        err => {
          this.errorSubject.next(true);
        });
  }

  connect(collectionViewer: CollectionViewer): Observable<ModelEventiCalamitosi.CampoModuloDTO[]> {
    return this.campoSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.campoSubject.complete();
    this.loadingSubject.complete();
  }

}

